const ProductServiceLayout = () => import(/* webpackChunkName: "productService" */'@/components/productService/ProductServiceLayout')
const ProductList = () => import(/* webpackChunkName: "productService" */'@/components/productService/ProductList')
const ProductAdd = () => import(/* webpackChunkName: "productService" */'@/components/productService/ProductAdd')
const ProductEdit = () => import(/* webpackChunkName: "productService" */'@/components/productService/ProductEdit')
const ProductDetail = () => import(/* webpackChunkName: "productService" */'@/components/productService/ProductDetail')
const ServiceList = () => import(/* webpackChunkName: "productService" */'@/components/productService/ServiceList')
const ServiceAdd = () => import(/* webpackChunkName: "productService" */'@/components/productService/ServiceAdd')
const ServiceEdit = () => import(/* webpackChunkName: "productService" */'@/components/productService/ServiceEdit')
const ServiceDetail = () => import(/* webpackChunkName: "productService" */'@/components/productService/ServiceDetail')
const ServiceLibrary = () => import(/* webpackChunkName: "productService" */'@/components/productService/ServiceLibrary')
const ServiceLibraryDetail = () => import(/* webpackChunkName: "productService" */'@/components/productService/ServiceLibraryDetail')
const ProductLibrary = () => import(/* webpackChunkName: "productService" */'@/components/productService/ProductLibrary')
const ProductLibraryDetail = () => import(/* webpackChunkName: "productService" */'@/components/productService/ProductLibraryDetail')
const ProductLibraryEdit = () => import(/* webpackChunkName: "productService" */'@/components/productService/ProductLibraryEdit')
const CardManagementSetting = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementSetting')
const CardManagementList = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementList')
const CardManagementAddShell = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementAddShell') // 选择壳牌养护卡
const CardManagementAdd = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementAdd') // 门店自建养护卡
const CardManagementAddTwo = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementAddTwo') // 门店自建养护卡第二步
const CardManagementAddShellTwo = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementAddShellTwo')  // 壳牌养护卡第二步
const CardManagementAddNew = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementAddNew') // 新卡新建/编辑
const CardManagementDetail = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementDetail')
const CardSelfBuild = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardSelfBuild') // 门店自建次卡
const ChooseShellCard = () => import(/* webpackChunkName: "productService" */'@/components/productService/ChooseShellCard')
const StatisticalList = () => import(/* webpackChunkName: "productService" */'@/components/productService/StatisticalList')
const StatisticalDetail = () => import(/* webpackChunkName: "productService" */'@/components/productService/StatisticalDetail')
const CardManagementAddStoredValue = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementAddStoredValue')
const CardManagementDetailNew = () => import(/* webpackChunkName: "productService" */'@/components/productService/CardManagementDetailNew')

export default {
  path: 'productService',
  component: ProductServiceLayout,
  children: [
    {
      name: 'productList',
      path: 'productList',
      component: ProductList,
      meta: {
        module: 'productService',
        keepAlive: true,
        isPreserve: false, // 是不是保存
        isOutside: false, // 是不是从tab切换进入
      },
    },
    {
      name: 'productEdit',
      path: 'productList/productEdit/:id',
      component: ProductEdit,
      meta: {
        module: 'productService',
        isSlibing: true,
      },
    },
    {
      name: 'productAdd',
      path: 'productList/productAdd',
      component: ProductAdd,
      meta: {
        module: 'productService',
        isSlibing: true,
      },
    },
    {
      name: 'productDetail',
      path: 'productList/productDetail/:id',
      component: ProductDetail,
      meta: {
        module: 'productService',
        isSlibing: true,
      },
    },
    {
      name: 'serviceList',
      path: 'service',
      component: ServiceList,
      meta: {
        module: 'productService',
        keepAlive: true,
        isPreserve: false, // 是不是保存
        isOutside: false, // 是不是从tab切换进入
      },
    },
    {
      name: 'serviceAdd',
      path: 'service/serviceAdd',
      component: ServiceAdd,
      meta: {
        module: 'productService',
        isSlibing: true,
      },
    },
    {
      name: 'serviceEdit',
      path: 'service/serviceEdit/:id',
      component: ServiceEdit,
      meta: {
        module: 'productService',
        isSlibing: true,
      },
    },
    {
      name: 'serviceDetail',
      path: 'service/serviceDetail/:id',
      component: ServiceDetail,
      meta: {
        module: 'productService',
        isSlibing: true,
      },
    },
    {
      name: 'serviceLibrary',
      path: 'serviceLibrary',
      component: ServiceLibrary,
      meta: {
        module: 'productService',
        keepAlive: true,
      },
    },
    {
      name: 'serviceLibraryDetail',
      path: 'serviceLibrary/serviceLibraryDetail/:id',
      component: ServiceLibraryDetail,
      meta: {
        module: 'productService',
        isSlibing: true,
      },
    },
    {
      name: 'productLibrary',
      path: 'productLibrary',
      component: ProductLibrary,
      meta: {
        module: 'productService',
        keepAlive: true,
      },
    },
    {
      name: 'productLibraryEdit',
      path: 'productList/productLibraryEdit/:id',
      component: ProductLibraryEdit,
      meta: {
        module: 'productService',
        isSlibing: false,
      },
    },
    {
      name: 'productLibraryDetail',
      path: 'productLibrary/productLibraryDetail/:id',
      component: ProductLibraryDetail,
      meta: {
        module: 'productService',
        isSlibing: true,
      },
    },
    {
      name: 'cardManagementSetting',
      path: 'cardManagementSetting',
      component: CardManagementSetting,
      children: [
        {
          name: 'cardManagementList',
          path: 'cardManagementList',
          component: CardManagementList,
          meta: {
            module: 'productService',
          },
        },
        {
          name: 'statisticalList',
          path: 'statisticalList',
          component: StatisticalList,
          meta: {
            module: 'productService',
          },
        },
        {
          path: '/',
          redirect: {name: 'cardManagementList'},
        },
      ],
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardSelfBuild',
      path: 'cardManagementSetting/cardSelfBuild',
      component: CardSelfBuild,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardManagementAddStoredValue',
      path: 'cardManagementSetting/cardManagementAddStoredValue',
      component: CardManagementAddStoredValue,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardManagementDetailNew',
      path: 'cardManagementSetting/cardManagementDetailNew',
      component: CardManagementDetailNew,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardManagementAdd',
      path: 'cardManagementSetting/cardManagementAdd',
      component: CardManagementAdd,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardManagementAddTwo',
      path: 'cardManagementSetting/cardManagementAddTwo',
      component: CardManagementAddTwo,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardManagementAddShell',
      path: 'cardManagementSetting/cardManagementAddShell',
      component: CardManagementAddShell,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardManagementAddShellTwo',
      path: 'cardManagementSetting/cardManagementAddShellTwo',
      component: CardManagementAddShellTwo,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardManagementAddNew',
      path: 'cardManagementSetting/cardManagementAddNew',
      component: CardManagementAddNew,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'chooseShellCard',
      path: 'cardManagementSetting/chooseShellCard',
      component: ChooseShellCard,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'cardManagementDetail',
      path: 'cardManagementSetting/cardManagementDetail',
      component: CardManagementDetail,
      meta: {
        module: 'productService',
      },
    },
    {
      name: 'statisticalDetail',
      path: 'cardManagementSetting/statisticalDetail',
      component: StatisticalDetail,
      meta: {
        module: 'productService',
      },
    },
    {
      path: '/',
      redirect: {
        name: 'productList',
      },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/productService.js